<template>
  <div class="social-auth">
    <div
      v-if="social_auth.facebook"
      @click="login('facebook')"
      class="item"
      :style="{background:'url('+facebook+')',backgroundSize:'100% 100%'}"
    ></div>
    <div
      v-if="social_auth.google"
      @click="login('google')"
      class="item"
      :style="{background:'url('+google+')',backgroundSize:'100% 100%'}"
    ></div>
    <!-- <div
      @click="login('twitter')"
      class="item"
      :style="{background:'url('+twitter+')',backgroundSize:'100% 100%'}"
    ></div>-->
    <div
      v-if="social_auth.amazon"
      @click="login('amazon')"
      class="item"
      :style="{background:'url('+amazon+')',backgroundSize:'100% 100%'}"
    ></div>
  </div>
</template>

<script>
import facebook from "@/images/Facebook.png";
import amazon from "@/images/amazon1.png";
import google from "@/images/google.png";
import twitter from "@/images/twitter.png";
export default {
  props: ["social_auth"],
  data() {
    return {
      redirect_uri: null,
      facebook,
      amazon,
      google,
      twitter,
      type: null
    };
  },
  methods: {
    async login(e) {
      this.type = e;
      const newWindow = window.open(
        "",
        "newwindow",
        "height=500, width=400, top=50%, left=50%, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no"
      );
      let res = await this.$axios.get(`/api/store/login/${e}/redirect`);
      newWindow.location.href = res.data.redirect_uri;
      window.addEventListener("message", this.receiveMessage, false);
    },
    async receiveMessage(event) {
      if (!event.data.authorizedError || event.data.authorizedError != "") {
        await this.$axios.post(
          `/api/store/login/${this.type}/callback`,
          event.data.data
        );
        window.location.href = "/";
      } else {
        this.$message.error("Login failed. Please log in again!");
      }
    }
  },
  mounted() {
    console.log("social_auth", this.social_auth);
  }
};
</script>

<style scoped lang='scss'>
.social-auth {
  .item {
    display: inline-block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin: 0 10px;
    cursor: pointer;
  }
}
</style>